import { DisplayName } from '@uplift/utils';
import React from 'react';
import { DesktopInfoComponent } from './info.desktop';
import { MobileInfoComponent } from './info.mobile';
import { useUpBreakpoint } from '@uplift/hooks';

export type InfoComponentProps = {
  isClientInTheCall?: boolean;
  userName: DisplayName;
  userAvatar?: string;
  startTime: string;
  endTime: string;
  sessionNote: string;
  companionRole?: string;
  onSubmit: (any) => void;
  startButtonDisabled: boolean;
  blurAvailable: boolean;
};

export const InfoComponent: React.VFC<InfoComponentProps> = props => {
  const isMdUp = useUpBreakpoint('md');


  return isMdUp ? (
    <DesktopInfoComponent {...props} />
  ) : (
    <MobileInfoComponent {...props} />
  );
};
